import React, { useCallback } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';

import {
  REQUEST_DURATION_SORT_LABELS,
  setSortRequestField,
  setSortRequestType,
  sortRequestFieldSelector,
  sortRequestTypeSelector,
} from 'features/courseResume';
import SortableTableCell from 'components/SortableTableCell';
import styles from './CoursePausePendingRequestsTableHeader.module.scss';
import TableCell from 'components/TableCell';
import TableHead from 'components/TableHead';
import TableRow from 'components/TableRow';

function CoursePausePendingRequestsTableHeader() {
  const dispatch = useDispatch();
  const sortValue = useSelector(sortRequestTypeSelector);
  const sortField = useSelector(sortRequestFieldSelector);

  const onSortChange = useCallback(
    (field, value) => {
      batch(() => {
        dispatch(setSortRequestType(value));
        dispatch(setSortRequestField(field));
      });
    },
    [dispatch]
  );

  return (
    <TableHead className={styles.root}>
      <TableRow>
        <TableCell className={styles.heading}>Learner Email</TableCell>
        <TableCell className={styles.heading}>Pause from</TableCell>
        <SortableTableCell
          field="duration_of_pause"
          ascLabel={REQUEST_DURATION_SORT_LABELS.ascLabel}
          descLabel={REQUEST_DURATION_SORT_LABELS.descLabel}
          onSortChange={onSortChange}
          sortValue={sortValue}
          sortField={sortField}
        >
          Duration
        </SortableTableCell>
        <TableCell className={styles.heading}>Suggested Super Batch</TableCell>
        <TableCell className={styles.heading}>Note</TableCell>
        <TableCell className={styles.heading}>Action</TableCell>
      </TableRow>
    </TableHead>
  );
}

export default CoursePausePendingRequestsTableHeader;
